import React, { useState } from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

export default function TicketTrends() {
  const [range, setRange] = useState("Monthly");
  const [open, setOpen] = useState(false);

  const dataSets = {
    Today: [45, 60, 55, 70, 65, 60, 75],
    Weekly: [80, 100, 120, 90, 110, 130, 120],
    Monthly: [140, 150, 180, 140, 140, 165, 165],
  };

  const created = dataSets[range];
  const resolved = created.map((v) => v - 75);

  const chartOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
    },

    stroke: {
      curve: "smooth",
      width: 2,
    },

    colors: ["#f97316", "#0f3d3e"],

    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.25,
        opacityTo: 0.02,
      },
    },

    markers: {
      size: 4,
      colors: ["#f97316", "#0f3d3e"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: { size: 6 },
    },

    grid: {
      borderColor: "#e5e7eb",
      strokeDashArray: 4,
    },

    xaxis: {
      categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      labels: {
        style: { fontSize: "12px", colors: "#6b7280" },
      },
    },

    yaxis: {
      labels: {
        style: { fontSize: "12px", colors: "#6b7280" },
      },
    },

    tooltip: {
      custom: function ({ series, dataPointIndex }) {
        return `
          <div style="
            background:#fff;
            padding:14px;
            border-radius:5px;
            box-shadow:0 8px 20px rgba(0,0,0,0.1);
            font-size:13px;
            
          ">
            <div style="font-weight:600;margin-bottom:8px;">
              September
            </div>

            <div style="display:flex;gap:20px;">
              <div>
                <span style="color:#f97316;">● Created</span>
                <div style="font-size:18px;font-weight:600;">
                  ${series[0][dataPointIndex]}
                </div>
              </div>

              <div>
                <span style="color:#0f3d3e;">● Resolved</span>
                <div style="font-size:18px;font-weight:600;">
                  ${series[1][dataPointIndex]}
                </div>
              </div>
            </div>
          </div>
        `;
      },
    },
  };

  return (
    <Card style={styles.card}>
      <Card.Body>

        {/* HEADER */}
        <div style={styles.header}>
          <h5 style={styles.title}>Ticket Trends</h5>

          {/* CUSTOM DROPDOWN */}
          <div style={{ position: "relative" }}>
            <button
              style={styles.dropdownBtn}
              onClick={() => setOpen(!open)}
            >
              <FiCalendar size={14} /> {range}
            </button>

            {open && (
              <div style={styles.dropdown}>
                {["Today", "Weekly", "Monthly"].map((item) => (
                  <div
                    key={item}
                    style={styles.dropdownItem}
                    onClick={() => {
                      setRange(item);
                      setOpen(false);
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* GRAPH */}
        <Chart
          options={chartOptions}
          series={[
            { name: "Created", data: created },
            { name: "Resolved", data: resolved },
          ]}
          type="area"
          height={260}
        />

        {/* LEGEND */}
        <div style={styles.legend}>
          <span style={{ color: "#f97316" }}>● Created</span>
          <span style={{ color: "#0f3d3e" }}>● Resolved</span>
        </div>

      </Card.Body>
    </Card>
  );
}

/* STYLES */
const styles = {
  card: {
    borderRadius: 5,
     border: "2px solid #e5e7eb"
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 10,
  },

  title: {
    fontWeight: 600,
  },

  dropdownBtn: {
    border: "1px solid #e5e7eb",
    background: "#fff",
    padding: "6px 10px",
    borderRadius: 8,
    fontSize: 13,
    display: "flex",
    alignItems: "center",
    gap: 5,
  },

  dropdown: {
    position: "absolute",
    top: 40,
    right: 0,
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    overflow: "hidden",
    zIndex: 10,
  },

  dropdownItem: {
    padding: "10px 16px",
    cursor: "pointer",
  },

  legend: {
    display: "flex",
    justifyContent: "center",
    gap: 20,
    marginTop: 10,
    fontSize: 13,
  },
};